<!-- 静态页面-->
<template>
	<div class="container">
		<el-container v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
			<el-header class="header">
				<div class="logo">
					<span>
						渠道管理系统 V2.0.0
					</span>
					<el-menu mode="horizontal" router background-color="#303133" text-color="#fff"
						active-text-color="#ffd04b">
						<el-submenu index="name">
							<template slot="title"><i class="iconfont">&#xe611;</i>{{name}}</template>
						</el-submenu>
						<el-menu-item @click="logout"><i class="iconfont">&#xe606;</i>退出</el-menu-item>
					</el-menu>
				</div>
			</el-header>
			<el-container>
				<el-aside class="aside" width="200px" :style="menuHeight" v-if="menuLoad">
					<el-menu background-color="#606266" router text-color="#fff" active-text-color="#ffd04b">
						<template>
							<el-submenu index="f">
								<template slot="title">
									<el-badge :value="count.new_order_count + count.refunding_count" class="item">
										<i class="iconfont">&#xe642;</i>订单管理
									</el-badge>
								</template>
								<el-menu-item :index="'/Indent/index.html'" v-auth="['store/order/list']">
									<el-badge :value="count.new_order_count" class="item">
										<i class="iconfont">&#xe702;</i>订单汇总
									</el-badge>
								</el-menu-item>
								<el-menu-item :index="'/Indent/dropShipping.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>待发货
								</el-menu-item>
								<el-menu-item :index="'/Indent/forGoods.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>待收货
								</el-menu-item>
								<el-menu-item :index="'/Indent/completed.html'" v-auth="['store/order/list']">
									<i class="iconfont">&#xe702;</i>已完成
								</el-menu-item>
<!--								<el-menu-item :index="'/Refund/index.html'" v-auth="['store/order.refund/list']">-->
<!--									<el-badge :value="count.refunding_count" class="item">-->
<!--										<i class="iconfont">&#xe702;</i>售后管理-->
<!--									</el-badge>-->
<!--								</el-menu-item>-->
							</el-submenu>
							<el-submenu index="c">
								<template slot="title">
									<i class="iconfont">&#xe642;</i>财务管理
								</template>
								<el-menu-item :index="'/Credit/index.html'">
									<i class="iconfont">&#xe702;</i>额度明细
								</el-menu-item>
							</el-submenu>
						</template>
					</el-menu>
				</el-aside>
				<el-container>
					<el-main :style="mainHeight">
						<transition name="el-fade-in-linear">
							<router-view v-if="menuLoad" class="router-view"></router-view>
						</transition>
					</el-main>
					<el-footer height="40px">
					</el-footer>
				</el-container>
			</el-container>
		</el-container>
	</div>
</template>
<script>
export default {
	data() {
		return {
			mainHeight: {
				height: ""
			},
			menuHeight: {
				height: "",
				"overflow-x": "hidden",
			},
			isLoad: false,
			menu: [],
			user:{},
			name: localStorage.login_name,
			menuLoad: false,
			count: {}
		}
	},
	watch: {
		$route: function (e) {
			this.loadMain();
		}
	},
	created() {
		window.addEventListener("resize", this.setHeight);
		this.setHeight();
		this.loadMenu()
		this.loadData()
	},
	mounted() {
		this.loadMain()
	},
	methods: {
		loadMain: function () {
			//获取统计信息
			this.axios.get('channelv1/data/count').then(res => {
				this.count = res.data.count
			}).catch((res) => {

			})
		},
		loadMenu(val){
			this.axios.get('channelv1/data/menus').then(res => {
				this.menuLoad = true
				this.$store.dispatch('admin/user/set', {
					user: res.data.user,
					access: res.data.menus,
				});
			}).catch(() => {
			})
		},
		setHeight() {
			this.mainHeight.height = window.innerHeight - 100 + "px";
			this.menuHeight.height = window.innerHeight - 60 + "px";
		},
		loadData() {
			this.isLoad = !this.isLoad
			this.axios.get('channelv1/data/menus').then(res => {
				this.isLoad = !this.isLoad
				this.user = res.data.user
				this.menu = res.data.menus
			}).catch(() => {
				this.isLoad = !this.isLoad
			})
		},
		logout() {
			localStorage.clear();
			this.$message.success({
				message: '退出成功'
			});
			this.$router.replace({
				path: '/Login.html'
			});
		}
	}
}
</script>
<style scoped>
	.el-menu-item.is-active {
		background-color: #444444 !important;
	}

	.iconfont {
		vertical-align: middle;
		margin-right: 5px;
		margin-top: -4px;
		width: 24px;
		text-align: center;
		font-size: 18px;
		color: rgb(255, 255, 255);
	}

	.main {
		min-height: 100%;
		padding: 20px;
	}

	.el-main {
		padding: 0;
	}

	.container .header {
		background: #303133;
	}

	.container .el-menu {
		height: 100%;
		border: none;
	}

	.container .logo {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.container .logo span {
		color: rgb(255, 208, 75);
		font-size: 18px;
	}

	.container .el-footer {
		background-color: #DCDFE6;
		align-items: center;
		display: flex;
	}
	.aside::-webkit-scrollbar{display:none;}
</style>
